var exports = {
  "z5": "DirectMessageList.module__dmListContainer___UDd5dn",
  "DS": "DirectMessageList.module__dmListHeader___UDd5dn",
  "vW": "DirectMessageList.module__dmListHeaderButton___UDd5dn",
  "sf": "DirectMessageList.module__dmListHeaderText___UDd5dn",
  "LF": "DirectMessageList.module__dmListHeaderShortcut___UDd5dn",
  "AA": "DirectMessageList.module__mobileContainer___UDd5dn",
  "Od": "DirectMessageList.module__mobileHeader___UDd5dn",
  "yG": "DirectMessageList.module__mobileHeaderTitle___UDd5dn",
  "Fy": "DirectMessageList.module__mobileHeaderActions___UDd5dn",
  "Y0": "DirectMessageList.module__mobileHeaderButton___UDd5dn",
  "OB": "DirectMessageList.module__mobileAddFriendButton___UDd5dn",
  "FG": "DirectMessageList.module__mobileAddFriendBadge___UDd5dn",
  "_D": "DirectMessageList.module__mobileScrollerContent___UDd5dn",
  "rj": "DirectMessageList.module__desktopScroller___UDd5dn",
  "bR": "DirectMessageList.module__mobileScroller___UDd5dn",
  "cB": "DirectMessageList.module__mobileFab___UDd5dn",
  "gT": "DirectMessageList.module__scrollerContent___UDd5dn",
  "e6": "DirectMessageList.module__desktopBottomSpacer___UDd5dn",
  "KW": "DirectMessageList.module__clickableItem___UDd5dn",
  "ZE": "DirectMessageList.module__clickableItemIcon___UDd5dn",
  "xC": "DirectMessageList.module__clickableItemSelected___UDd5dn" + " " + "DirectMessageList.module__clickableItem___UDd5dn",
  "Wo": "DirectMessageList.module__clickableItemInner___UDd5dn",
  "Je": "DirectMessageList.module__clickableItemContent___UDd5dn",
  "AO": "DirectMessageList.module__sendIcon___UDd5dn",
  "hV": "DirectMessageList.module__clickableItemText___UDd5dn",
  "Ax": "DirectMessageList.module__dmSectionSeparator___UDd5dn",
  "MN": "DirectMessageList.module__dmSectionHeader___UDd5dn",
  "Pc": "DirectMessageList.module__dmSectionHeaderText___UDd5dn",
  "il": "DirectMessageList.module__dmSectionHeaderLabel___UDd5dn",
  "yt": "DirectMessageList.module__dmCreateButton___UDd5dn",
  "Qv": "DirectMessageList.module__dmCreateButtonTooltipTarget___UDd5dn",
  "$z": "DirectMessageList.module__dmChannelList___UDd5dn",
  "hZ": "DirectMessageList.module__dmItemMobile___UDd5dn",
  "so": "DirectMessageList.module__dmItemMobileSelected___UDd5dn" + " " + "DirectMessageList.module__dmItemMobile___UDd5dn",
  "k1": "DirectMessageList.module__dmItemMobileUnread___UDd5dn" + " " + "DirectMessageList.module__dmItemMobile___UDd5dn",
  "AM": "DirectMessageList.module__dmItemMobileMuted___UDd5dn",
  "Vw": "DirectMessageList.module__dmItem___UDd5dn",
  "Mg": "DirectMessageList.module__dmItemUnread___UDd5dn" + " " + "DirectMessageList.module__dmItem___UDd5dn",
  "Go": "DirectMessageList.module__dmItemMuted___UDd5dn",
  "OV": "DirectMessageList.module__dmItemUnreadIndicatorContainer___UDd5dn",
  "Md": "DirectMessageList.module__dmItemUnreadIndicatorContainerMobile___UDd5dn" + " " + "DirectMessageList.module__dmItemUnreadIndicatorContainer___UDd5dn",
  "wE": "DirectMessageList.module__dmItemUnreadIndicatorContainerDesktop___UDd5dn" + " " + "DirectMessageList.module__dmItemUnreadIndicatorContainer___UDd5dn",
  "tD": "DirectMessageList.module__dmItemUnreadIndicator___UDd5dn",
  "A0": "DirectMessageList.module__dmItemContent___UDd5dn",
  "XW": "DirectMessageList.module__dmItemAvatarWrapper___UDd5dn",
  "F6": "DirectMessageList.module__dmItemInfo___UDd5dn",
  "wu": "DirectMessageList.module__dmItemName___UDd5dn",
  "NA": "DirectMessageList.module__dmItemNameText___UDd5dn",
  "IC": "DirectMessageList.module__dmItemUserTag___UDd5dn",
  "Xl": "DirectMessageList.module__dmItemPinIcon___UDd5dn",
  "qj": "DirectMessageList.module__dmItemSubtext___UDd5dn",
  "EL": "DirectMessageList.module__dmItemCustomStatus___UDd5dn" + " " + "DirectMessageList.module__dmItemSubtext___UDd5dn",
  "Y9": "DirectMessageList.module__dmItemSelected___UDd5dn" + " " + "DirectMessageList.module__dmItem___UDd5dn",
  "ZQ": "DirectMessageList.module__dmItemMembersSubtext___UDd5dn" + " " + "DirectMessageList.module__dmItemSubtext___UDd5dn",
  "Qm": "DirectMessageList.module__dmItemSubtextItalic___UDd5dn",
  "s4": "DirectMessageList.module__dmItemPreviewMarkdown___UDd5dn",
  "Rt": "DirectMessageList.module__dmItemTimestamp___UDd5dn",
  "Xk": "DirectMessageList.module__dmItemCloseButton___UDd5dn",
  "S5": "DirectMessageList.module__mobileSpecialButton___UDd5dn" + " " + "DirectMessageList.module__dmItemMobile___UDd5dn",
  "tN": "DirectMessageList.module__mobileSpecialButtonSelected___UDd5dn" + " " + "DirectMessageList.module__dmItemMobileSelected___UDd5dn" + " " + "DirectMessageList.module__dmItemMobile___UDd5dn",
  "Ml": "DirectMessageList.module__mobilePersonalNotesButton___UDd5dn" + " " + "DirectMessageList.module__mobileSpecialButton___UDd5dn" + " " + "DirectMessageList.module__dmItemMobile___UDd5dn",
  "zh": "DirectMessageList.module__mobilePersonalNotesButtonSelected___UDd5dn" + " " + "DirectMessageList.module__mobileSpecialButtonSelected___UDd5dn" + " " + "DirectMessageList.module__dmItemMobileSelected___UDd5dn" + " " + "DirectMessageList.module__dmItemMobile___UDd5dn",
  "iu": "DirectMessageList.module__mobilePlutoniumButton___UDd5dn" + " " + "DirectMessageList.module__mobileSpecialButton___UDd5dn" + " " + "DirectMessageList.module__dmItemMobile___UDd5dn",
  "ju": "DirectMessageList.module__dmItemMobilePressed___UDd5dn",
  "lY": "DirectMessageList.module__contextMenuActive___UDd5dn",
  "dJ": "DirectMessageList.module__mobileSpecialButtonContent___UDd5dn",
  "H8": "DirectMessageList.module__mobileSpecialButtonIcon___UDd5dn",
  "Rg": "DirectMessageList.module__mobileSpecialButtonText___UDd5dn",
  "E5": "DirectMessageList.module__mobileSpecialButtonLabel___UDd5dn",
  "yY": "DirectMessageList.module__iconSize5___UDd5dn",
  "Ff": "DirectMessageList.module__iconSize4___UDd5dn",
};

module.exports = exports;
